module.exports = __webpack_public_path__ + "img/PV-CYCLE.62b8aeb2.png";